import { useEffect, useRef } from 'react';
import { SearchIcon, CommandIcon } from 'lucide-react';
interface GlobalSearchBarProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
}
export function GlobalSearchBar({
  value = '',
  onChange,
  placeholder = "Search families, students, or type 'Status: Overdue'..."
}: GlobalSearchBarProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Check for Cmd+K (Mac) or Ctrl+K (Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
  return (
    <div className="relative w-full mb-8">
      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
        <SearchIcon className="h-5 w-5 text-text-tertiary" />
      </div>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        className="block w-full pl-11 pr-16 py-3.5 bg-surface-light border border-border rounded-[12px] shadow-sm font-body text-[15px] text-iron-grey placeholder:text-text-tertiary outline-none transition-all" />
      
      <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none">
        <div className="hidden sm:flex items-center gap-1 px-2 py-1 rounded-[6px] bg-muted border border-border text-[11px] font-medium text-text-secondary font-mono">
          <CommandIcon className="w-3 h-3" />
          <span>K</span>
        </div>
      </div>
    </div>);

}
